import React from "react";
import { useAuth } from "@talis/auth-js";
import { Spinner } from "@/components/common/Loading";

/**
 * Auth gate around the whole app. AuthProvider (configured with
 * ssoStartPath="/sso/start") auto-redirects unauthenticated loads to the
 * backend OIDC entrypoint, so the splash below is mostly a fallback for the
 * brief window before that redirect fires (or if it's suppressed).
 *
 * Gates on authentication ONLY — kraken admits any authenticated user and
 * scopes visibility by org, so there is deliberately no permission gate here.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <Spinner />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <div className="text-center space-y-md max-w-sm px-md">
          <h1 className="text-3xl font-semibold tracking-tight text-text">Krakensense</h1>
          <p className="text-textLight">qPCR fleet dashboard</p>
          <a
            href="/sso/start?next=/devices"
            className="inline-block px-lg py-sm rounded-md bg-brand text-white font-medium shadow-card hover:bg-brand-dark transition-colors"
          >
            Sign in
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
